import React, { useEffect } from "react";
import {
  Typography, Grid, Paper,
} from "@material-ui/core";
import ContractListForm from '../component/portal/contractlist/ContractListForm'
import ContractListResult from '../component/portal/contractlist/ContractListResult'
import { getContractList, typeContractList, getAllContractList, typeCisUserList, getCisUserList } from '../api/helpline/keiyaku'
import { useDispatch, useGlobalState } from "../provider/Provider";
import { getCustomerList, typeCustomerList } from "../api/helpline/qa";
import { getSessionStorageConForm, isSessionStorageConForm, removeSessionStorageCon, removeSessionStorageConForm } from "../User";
import { getUserInfo } from "../api/helpline/user";

interface Prop {
  handleError: (err: any) => void,
  handleClickKeiyakuno: (num: string) => void,

}

interface Form {
  userId: string,
  keiyakuClsCd: string,
  salesPersonCd: string,
  renewalMonth: number[],
  demandMonth: number[],
}


const ContractList: React.FC<Prop> = (props) => {
  const globalState = useGlobalState('user')
  const globalqalistState = useGlobalState('qalist')
  const globalconlistState = useGlobalState('contractlist')
  const { backpage } = useGlobalState('page')
  const dispatch = useDispatch()
  const { userId, token, role } = globalState
  const { handleError, handleClickKeiyakuno } = props
  const monthList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
  const [form, setForm] = React.useState<Form>({
    userId: '',
    keiyakuClsCd: '',
    salesPersonCd: '',
    renewalMonth: [],
    demandMonth: [],
  })

  //顧客情報
  const [customerList, setCustomerList] = React.useState<typeCustomerList[]>([])
  //CIS社員情報
  const [cisUserList, setCisUserList] = React.useState<typeCisUserList[]>([])
  //契約項目全取得
  const [contractList, setContractList] = React.useState<typeContractList[]>()
  const [loginUser, setLoginUser] = React.useState(false)
  const pageSize: number = 30
  const [loading, setLoading] = React.useState<boolean>(false)
  const handleChangeForm = (event: React.ChangeEvent<{ value: unknown; name?: string | undefined; }>) => {
    if (event.target.name === "renewalMonth" || event.target.name === "demandMonth") {
      setForm({
        ...form,
        [event.target.name as string]: event.target.value as []
      })
    } else {
      setForm({
        ...form,
        [event.target.name as string]: event.target.value as string
      })
    }
  }

  const chipDelete = (i: number, name: string) => {
    if (name === "renewalMonth") {
      setForm({
        ...form,
        renewalMonth: form.renewalMonth.filter(value => value !== i),
      })
    } else if (name === "demandMonth") {
      setForm({
        ...form,
        demandMonth: form.demandMonth.filter(value => value !== i),
      })
    }

  }

  const setSessionform = (form: Form) => {
    removeSessionStorageConForm()
    const setstr = unescape(encodeURIComponent(JSON.stringify(form)))
    sessionStorage.setItem('SESSIONCONFORM', btoa(setstr));
  }

  const onSubmit = () => {
    setLoading(true)
    if (backpage) {
      dispatch({ type: 'SET_PAGE', payload: globalState, page: { backpage: false, }, qalist: globalqalistState, contractlist: globalconlistState })
    }
    removeSessionStorageCon()//remove Contract Result session
    if (loginUser) {
      getUserInfo(userId, userId, token, role).then(res => {//ログインユーザーSEcd取得
        let sesObj = Object.assign({}, form)
        sesObj["salesPersonCd"] = res.userCd
        setSessionform(sesObj)//set ContractForm
        getContractList(form.userId, userId, token, role, form.keiyakuClsCd, res.userCd, form.renewalMonth.join(','), form.demandMonth.join(',')).then(res => {
          dispatch({ type: 'SET_CONLIST', payload: globalState, page: { backpage: false, }, qalist: globalqalistState, contractlist: res })
          setLoading(false)
        }).catch(err => { handleError(err); setLoading(false) })
      }).catch(err => { handleError(err); setLoading(false) })
    } else {
      setSessionform(form)//set ContractForm
      getContractList(form.userId, userId, token, role, form.keiyakuClsCd, form.salesPersonCd, form.renewalMonth.join(','), form.demandMonth.join(',')).then(res => {
        dispatch({ type: 'SET_CONLIST', payload: globalState, page: { backpage: false, }, qalist: globalqalistState, contractlist: res })
        setLoading(false)
      }).catch(err => { handleError(err); setLoading(false) })
    }
  }

  const handleChangeCompanyCd = (companyObj: typeCustomerList | null) => {
    if (companyObj) {
      setForm({
        ...form,
        userId: companyObj.departmentCd
      })
    } else {
      setForm({
        ...form,
        userId: ''
      })
    }
  }
  const handleChangeKeiyakuCd = (keiyakuObj: typeContractList | null) => {
    if (keiyakuObj) {
      setForm({
        ...form,
        keiyakuClsCd: keiyakuObj.keiyakuClsCd
      })
    } else {
      setForm({
        ...form,
        keiyakuClsCd: ''
      })
    }
  }

  const handleChangeSalesCd = (seObj: typeCisUserList | null) => {
    if (seObj) {
      setForm({
        ...form,
        salesPersonCd: seObj.userCd
      })
    } else {
      setForm({
        ...form,
        salesPersonCd: ''
      })
    }
  }

  const handleSetLoginUserCd = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoginUser(event.target.checked)
  }

  useEffect(() => {
    let cleanup = false
    if (userId && token && role) {
      //戻るボタン押下時にformを復元
      if (globalconlistState.length !== 0 && isSessionStorageConForm() && backpage) {
        const [resform] = getSessionStorageConForm()
        setForm({
          ...form,
          userId: resform.userId,
          keiyakuClsCd: resform.keiyakuClsCd,
          salesPersonCd: resform.salesPersonCd,
          renewalMonth: resform.renewalMonth,
          demandMonth: resform.demandMonth,
        })
        dispatch({//復元
          type: 'SET_CONLIST', payload: globalState, page: { backpage: backpage }, qalist: [], contractlist: globalconlistState
        })
      } else {
        dispatch({//初期化
          type: 'SET_CONLIST', payload: globalState, page: { backpage: backpage }, qalist: [], contractlist: []
        })
      }
      //顧客情報全取得
      getCustomerList(userId, token, role, '').then(res => { if (!cleanup) { setCustomerList(res) } }).catch(err => handleError(err))
      //契約項目全取得
      getAllContractList(userId, token, role).then(res => { if (!cleanup) { setContractList(res) } }).catch(err => handleError(err))
      //CIS社員情報
      getCisUserList(userId, token, role, '').then(res => {
        if (!cleanup) {
          setCisUserList(res)
          dispatch({//backpage 初期化
            type: 'SET_PAGE', payload: globalState, page: { backpage: false, }, qalist: globalqalistState, contractlist: globalconlistState
          })
        }
      }).catch(err => handleError(err))
      return () => { cleanup = true }
    }
  }, [userId, token])

  return (
    <React.Fragment>
      <Typography variant="h6"> 契約情報一覧</Typography>
      <Grid container spacing={2} justify="center" >
        <Grid item xs={12}>
          <Paper>
            <ContractListForm contractList={contractList} form={form} monthList={monthList} handleChangeForm={handleChangeForm} chipDelete={chipDelete} onSubmit={onSubmit} customerList={customerList} handleChangeCompanyCd={handleChangeCompanyCd} handleChangeKeiyakuCd={handleChangeKeiyakuCd} cisUserList={cisUserList} handleChangeSalesCd={handleChangeSalesCd} loginUser={loginUser} handleSetLoginUserCd={handleSetLoginUserCd} loading={loading} />
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper>
            <ContractListResult pageSize={pageSize} handleClickKeiyakuno={handleClickKeiyakuno} />
          </Paper>
        </Grid>
      </Grid>
    </React.Fragment >
  )
}
export default ContractList;